/**
 * The default center coordinates for the map; currently set to the center of the United States.
 */
export const DEFAULT_CENTER = Object.freeze({
  lat: 39.8283,
  lng: -98.5795,
});
